<template>
  <div class="side-float-btns">
    <a class="btn" tabindex="0" v-if="consultUrl" @click="goConsultUrl" title="图标链接：智能咨询">
      <img src="~@/assets/img/column/customer.svg" title="图标链接：智能咨询" alt="图标链接：智能咨询">
      <span>智能咨询</span>
    </a>
    <a class="btn" tabindex="0" v-if="$route.path == '/subjectsService'" @click="goUserCenter" title="图标链接：办理进度">
      <img src="~@/assets/img/column/progress.svg" title="图标链接：办理进度" alt="图标链接：办理进度">
      <span>办理进度</span>
    </a>
    <a class="btn" tabindex="0" v-else-if="$route.path == '/graphicInstructions' && isOnlineApply == 1" @click="handleNow" title="图标链接：立即办理">
      <img src="~@/assets/img/graphic/handleNow.svg" title="图标链接：立即办理" alt="图标链接：立即办理">
      <span>立即办理</span>
    </a>
    <button class="btn" tabindex="0" @click="toTop" title="图标：返回顶部">
      <img src="~@/assets/img/column/top.svg" title="图标：返回顶部" alt="图标：返回顶部">
      <span>返回顶部</span>
    </button>
  </div>
</template>

<script>
import {interOutnetConfig} from "../utils/jointApplyUrl";

export default {
  data() {
    return {
      consultUrl: '',
      isOnlineApply: ''
    };
  },
  methods: {
    goConsultUrl() {
      window.open(this.consultUrl)
    },
    toTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    goUserCenter() {
      window.open(`${process.env.BASE_URL}myItem.html#/myThemeItem`)
    },
    handleNow() {
      this.$emit('handleNow')
    }
  },
  created() {
    interOutnetConfig({
      key: "UI_CONSULT_URL",
    }).then(res => {
      if (+res.status === 200) {
        this.consultUrl = res.data.value
      }
    })

    if (sessionStorage.getItem('baseInfo')) {
      this.isOnlineApply =  JSON.parse(sessionStorage.getItem('baseInfo')).isOnlineApply
    }
  },
};
</script>

<style lang="scss" scoped>
.side-float-btns{
  position: fixed;
  z-index: 999;
  top:54%;
  right: 0;
  border-bottom: 1px solid #D5D5D5;
  width: 80px;
  .btn{
    width: 80px;
    padding-top: 20px;
    padding-bottom: 10px;
    background: #FFFFFF;
    border: 1px solid #D5D5D5;
    border-bottom: none;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #727475;
    line-height: 21px;
    text-align: center;
    cursor: pointer;
    img{
      display: block;
      margin: 0 auto 8px;
    }
  }
  .btn:hover{
    background: #4391F4;
    color: #fff;
    img{
      position: relative;
      left: 5000px;
      filter: drop-shadow(#fff -5000px 0);
    }
  }
}
</style>
